//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../Annotations/Annotations.ArbitraryAreaSeedBuilderList.js";
import "../no/LineColorFontWidthBuilder.js";
import "../Annotations/Annotations.HatchFillSettingsBuilder.js";
import "../no/Expression.js";
import "../Annotations/Annotations.PlaneBuilder.js";
import "../no/SelectDisplayableObjectList.js";
import "../Annotations/Annotations.PmiRegionSettingsBuilder.js";
import "../no/Expression.js";
import "../no/LineColorFontWidthBuilder.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"Anchor",1,0],[1,"ArbitraryAreaList",0,"Annotations.ArbitraryAreaSeedBuilderList",0],[1,"BoundaryColorFontWidth",0,"LineColorFontWidthBuilder",1],[0,"ConformToSurface",1,0],[0,"CrosshatchColor",1,1],[1,"CrosshatchSettings",0,"Annotations.HatchFillSettingsBuilder",1],[0,"DisplayCrosshatch",1,1],[0,"EndPoint",1,"Point",0],[1,"Height",0,"Expression",0],[1,"InnerDiameter",0,"Expression",0],[0,"Origin",1,"Point",0],[1,"OuterDiameter",0,"Expression",0],[1,"Plane",0,"Annotations.PlaneBuilder",0],[1,"SelectCylindricalFace",0,"SelectDisplayableObjectList",0],[1,"SelectFace",0,"SelectDisplayableObjectList",0],[1,"Settings",0,"Annotations.PmiRegionSettingsBuilder",0],[0,"StartPoint",1,"Point",0],[0,"Type",1,0],[1,"Width",0,"Expression",0]],[[["inheritTag"],"InheritFrom",{},1,0]],[]];
SPLM.Annotations.RegionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.RegionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.RegionBuilder.Types = Object.freeze({
    "RectangularRegion" : "RectangularRegion", "CircularRegion" : "CircularRegion", "AnnularRegion" : "AnnularRegion", "CylindricalRegion" : "CylindricalRegion", "ArbitraryRegion" : "ArbitraryRegion"});

SPLM.Annotations.RegionBuilder.AlignmentPosition = Object.freeze({
    "TopLeft" : "TopLeft", "TopCenter" : "TopCenter", "TopRight" : "TopRight", "MiddleLeft" : "MiddleLeft", "MiddleCenter" : "MiddleCenter", "MiddleRight" : "MiddleRight", "BottomLeft" : "BottomLeft", "BottomCenter" : "BottomCenter", "BottomRight" : "BottomRight"});

SPLM.Annotations.RegionBuilder.CrosshatchPatterns = Object.freeze({
    "None" : "None", "GeneralUse" : "GeneralUse"});

export default SPLM;